import validate from "/opt/build/repo/nuxt/node_modules/.pnpm/nuxt@3.15.0_@netlify+blobs@8.1.2_@parcel+watcher@2.5.0_@types+node@22.10.3_db0@0.2.1_eslint@9_6ev2ucq3opj67dzr7iyo6z2iwm/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/build/repo/nuxt/node_modules/.pnpm/nuxt@3.15.0_@netlify+blobs@8.1.2_@parcel+watcher@2.5.0_@types+node@22.10.3_db0@0.2.1_eslint@9_6ev2ucq3opj67dzr7iyo6z2iwm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  preview: () => import("/opt/build/repo/nuxt/middleware/preview.ts")
}